import { useCampaignContext } from 'modules/campaigns/editor/context';
import { CHECKBOX_STATUS } from 'ui/checkbox/checkboxStatus';
import { Skeleton } from 'ui/skeleton';
import noop from 'utils/noop';
import { getIsEligibilityCampaign } from 'modules/campaigns/editor/components/utils';
import {
  Cell,
  CheckboxCell,
  ContactsCell,
  MultiLineLoadingCell,
  TableRow,
  TABLE_GRID,
  TABLE_GRID_ELIGIBILITY,
} from '../../AudienceSelection.styled';

export const SKELETON_ROW_TEST_ID = 'skeleton-row';
export const LOADING_SEND_CHECKBOX_ID = 'loading-send-checkbox';
export const LOADING_SUPPRESS_CHECKBOX_ID = 'loading-suppress-checkbox';

export const AudienceSelectionSkeletonRow = () => {
  const { campaign } = useCampaignContext();
  const isEligibility = getIsEligibilityCampaign(campaign.campaignTypeDefinition);

  const gridLayout = isEligibility ? TABLE_GRID_ELIGIBILITY : TABLE_GRID;

  return (
    <TableRow gridLayout={gridLayout} data-test={SKELETON_ROW_TEST_ID}>
      <CheckboxCell
        id={LOADING_SEND_CHECKBOX_ID}
        handleClick={noop}
        status={CHECKBOX_STATUS.UNCHECKED}
      />
      {!isEligibility && (
        <CheckboxCell
          id={LOADING_SUPPRESS_CHECKBOX_ID}
          handleClick={noop}
          status={CHECKBOX_STATUS.UNCHECKED}
        />
      )}
      <MultiLineLoadingCell>
        <Skeleton height={14} width={423} />
        <Skeleton height={14} width={328} />
      </MultiLineLoadingCell>
      <Cell>
        <Skeleton height={16} width={77} />
      </Cell>
      <Cell>
        <Skeleton height={16} width={77} />
      </Cell>
      <ContactsCell>
        <Skeleton height={16} width={58} />
      </ContactsCell>
      <MultiLineLoadingCell>
        <Skeleton height={14} width={111} />
        <Skeleton height={14} width={111} />
      </MultiLineLoadingCell>
    </TableRow>
  );
};
